<template>
  <div>
    <!-- 注册流程 -->
    <div class="stepBody">
      <template v-if="showStep">
        <div id="removeLeft">
          <van-steps
            :active="activeTag"
            v-model="currentIndex"
            activeColor="#E12817"
            :activeIcon="activeIcon"
            finish-icon="checked"
            :inactiveIcon="inactiveIcon"
          >
            <van-step v-for="(item, index) in stepData" :key="index" :class="'notStyle'+ index">{{
              item.label
            }}</van-step>
          </van-steps>
        </div>
      </template>
    </div>
    <div class="normalStyle" id="centerCont">
      <router-view />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import common from "../../common/commonMethods";

export default {
  data() {
    return {
      currentIndex: 0,
      active: null,
      activeIcon: require("@assets/images/risk/red.png"),
      inactiveIcon: require("@assets/images/risk/grey.png"),
      jumpFlow: require("@assets/images/risk/jump-flow.png"),
      // accountType:'notIdentity'
    };
  },
  computed: {
    ...mapState([
      //...函数名 使用对象展开运算符将此对象混入到外部对象中
      "getOpenAccount",
      "statusHeight",
      "submitPhoneNum", //开户是否做过银行卡
      "isRiskFlag", //开户是否做过风测
      "skipList",
      "baseInfoFromNative"
    ]),
    stepData() {
      if (this.getOpenAccount.accountType === "notIdentity") {
        return [
          { label: "01.实名信息" },
          { label: "02.个人相关信息" },
          { label: "03.税收身份说明" },
          { label: "04.绑定银行卡" },
          { label: "05.风险测评" },
          { label: "06.投资者类型认定" },
        ];
      } else {
        //开户
        let company = this.baseInfoFromNative.company || this.getOpenAccount.company || this.getOpenAccount.userCompanyId
        if (company != "1" &&  company != "5") {
          return [
            { label: "01.实名信息" },
            { label: "02.个人相关信息" },
            { label: "02.风险测评" },
            { label: "03.绑定银行卡" },
            { label: "04.投资者类型认定" },
          ];
        } else {
          return [
            { label: "01.实名信息" },
            // { label: "02.个人相关信息" },
            { label: "02.风险测评" },
            { label: "03.绑定银行卡" },
            { label: "04.投资者类型认定" },
          ];
        }
      }
    },
    showStep(){
      if (this.getOpenAccount.accountType === "notIdentity") {
        return this.$route.meta.notTag || this.$route.meta.notTag === 0
      } else {
        //开户
        return this.$route.meta.tag || this.$route.meta.tag === 0
      }
    },
    activeTag() {
      if (this.getOpenAccount.accountType === "notIdentity") {
        return this.$route.meta.notTag;
      } else {
        //开户
        return this.$route.meta.tag;
      }
    },
  },
  watch: {
    $route:{
      handler(newVal){
        if (newVal) {
          this.jumpItems(newVal);
          this.$nextTick(() => {
            this.notIndetitySkip()
            this.removeStepPosition();
          });
        }
      },
      immediate:true
    },
    statusHeight: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$nextTick(() => {
            let heig = Number(this.statusHeight.statusBar_height);
            let newH = heig + 48 + 68;
            let data = newH / 100 + "rem";
            let $dom = document.getElementById("centerCont");
            $dom.style.height = `calc(100vh - ${data})`;
          });
        }
      },
      deep: true,
      immediate: true,
    },
     "getOpenAccount.accountType":{
      handler(newV){
        if(newV){
          this.$nextTick(() => {
            this.notIndetitySkip()
            this.removeStepPosition();
        });
        }
      }
    },
    getOpenAccount: {
      handler(val) {
        this.removeStepPosition()
        if (val) {
          //没做过风测，变色变图标
          this.$store.commit("changeRiskFlag", val.isRiskFlag); //开户是否风测
          if (
            ((this.$route.path == "/personalProcess/bindCard" || this.$route.path == "/personalProcess/bindCardNew") &&
              !val.isRiskFlag) ||
            ((this.$route.path == "/personalProcess/investorIdentification" || this.$route.path == "/personalProcess/investorIdentificationNew") &&
              !val.isRiskFlag) ||
            (this.$route.path == "/personalProcess/uploadMaterial" &&
              !val.isRiskFlag)
          ) {
            let dom = document.getElementsByClassName("van-steps__items")[0];
            let domChirld = Array.from(
              dom.getElementsByClassName("van-step--finish")
            );
            let domChirldIndex = ((this.$route.path == "/personalProcess/bindCardNew" || this.$route.path == "/personalProcess/investorIdentificationNew") ? 1 : 2)
            domChirld[domChirldIndex].style.color = "#999999";
            this.$nextTick(() => {
            let domI = domChirld[domChirldIndex].getElementsByClassName(
              "van-step__icon--finish"
            )[0];
            if (domI) {
              domI.remove();
              let domR = domChirld[domChirldIndex].getElementsByClassName(
                "van-step__circle-container"
              )[0];
              let jumpDom = document.createElement("img");
              jumpDom.src = this.jumpFlow;
              jumpDom.style.width = "1em";
              jumpDom.style.height = "1em";
              domR.appendChild(jumpDom);
            }
            });
          }
        }
      },
    },
  },
  mounted() {
    this.jumpItems(this.$route);
    this.$nextTick(()=>{
      this.removeStepPosition();
    })
    
  },
  methods: {
    notIndetitySkip(){
      if(this.getOpenAccount.accountType === "notIdentity"){
        this.skipList.map((item)=>{
          let $dom1 = document.querySelector('.notStyle' + item)
          $dom1.style.color = "#999999";
          this.$nextTick(() => {
            //icon
            let domI = $dom1.getElementsByClassName(
              "van-step__icon--finish"
            )[0];
            if (domI) {
              domI.remove();
              let domR = $dom1.getElementsByClassName(
                "van-step__circle-container"
              )[0];
              let jumpDom = document.createElement("img");
              jumpDom.src = this.jumpFlow;
              jumpDom.style.width = "1em";
              jumpDom.style.height = "1em";
              jumpDom.style.paddingTop = "0.05rem";
              domR.appendChild(jumpDom);
            }
          });
        })
      }
    },
    removeStepPosition() {
      this.$nextTick(()=>{
        let $div = document.getElementsByClassName("stepBody")[0];
      let $div1 = document.getElementById("removeLeft");
      let tag = this.getOpenAccount.accountType === 'notIdentity' ? this.$route.meta.notTag : this.$route.meta.tag;
      let clientWidth = document.documentElement.clientWidth;
      if (this.getOpenAccount.accountType === "notIdentity") {
        $div1.setAttribute(
          "style",
          `width:${clientWidth + 570}px;padding-left:${
            clientWidth / 2 - 9
          }px;padding-right:${clientWidth / 2 - 9}px`
        );
      } else {
        if($div1){
          let company =  this.getOpenAccount.company || this.getOpenAccount.userCompanyId || this.baseInfoFromNative.company
          if(company == "1" ||  company == "5") {            
            $div1.setAttribute(
              "style",
              `width:${clientWidth + 368}px;padding-left:${
                clientWidth / 2 - 9
              }px;padding-right:${clientWidth / 2 - 9}px`
            );
          } else {
            $div1.setAttribute(
              "style",
              `width:${clientWidth + 460}px;padding-left:${
                clientWidth / 2 - 9
              }px;padding-right:${clientWidth / 2 - 9}px`
            );
          }
          

          switch (this.$route.path) {
            case "/personalProcess/realInfo":
              $div1.style.transform = "translateX(-10px)";
              break;
            case "/personalProcess/realInfoNew":
              $div1.style.transform = "translateX(-10px)";
              break;
            case "/personalProcess/personalInfoChild":
              $div1.style.transform = "translateX(30px)";
              break;
            case "/personalProcess/bindCard":
              common.getProvinceList();
              $div1.style.transform = "translateX(-38px)";
              break;
            case "/personalProcess/bindCardNew":
              common.getProvinceList();
              $div1.style.transform = "translateX(-38px)";
              break;
            default:
              break;
          }
        }

      }
      $div.scrollLeft = 115 * tag;
      })
      
    },
    jumpItems(routeObj) {
      if (
        ((routeObj.path == "/personalProcess/investorIdentification" || routeObj.path == "/personalProcess/investorIdentificationNew") &&
          !this.submitPhoneNum) ||
        (routeObj.path == "/personalProcess/uploadMaterial" &&
          !this.submitPhoneNum)
      ) {
        //跳过银行卡 - 变色变图标
        //文字
        let dom = document.getElementsByClassName("van-steps__items")[0];
        let domChirldIndex = (routeObj.path == "/personalProcess/investorIdentificationNew") ? 2 : 3
        let domChirld = Array.from(
          dom.getElementsByClassName("van-step--finish")
        );
        domChirld[domChirldIndex].style.color = "#999999";
        this.$nextTick(() => {
          //icon
          let domI = domChirld[domChirldIndex].getElementsByClassName(
            "van-step__icon--finish"
          )[0];
          if (domI) {
            domI.remove();
            let domR = domChirld[domChirldIndex].getElementsByClassName(
              "van-step__circle-container"
            )[0];

            let jumpDom = document.createElement("img");
            jumpDom.src = this.jumpFlow;
            jumpDom.style.width = "1em";
            jumpDom.style.height = "1em";
            domR.appendChild(jumpDom);
          }
        });
      }
      if (
        ((this.$route.path == "/personalProcess/bindCard" || this.$route.path == "/personalProcess/bindCardNew") && !this.isRiskFlag) ||
        ((this.$route.path == "/personalProcess/investorIdentification" || this.$route.path == "/personalProcess/investorIdentificationNew") &&
          !this.isRiskFlag) ||
        (this.$route.path == "/personalProcess/uploadMaterial" &&
          !this.isRiskFlag)
      ) {
        let dom = document.getElementsByClassName("van-steps__items")[0];
        let domChirldIndex = ((this.$route.path == "/personalProcess/bindCardNew" || this.$route.path == "/personalProcess/investorIdentificationNew") ? 1 : 2)
        let domChirld = Array.from(
          dom.getElementsByClassName("van-step--finish")
        );
        domChirld[domChirldIndex].style.color = "#999999";

        this.$nextTick(() => {
          let domI = domChirld[domChirldIndex].getElementsByClassName("van-step__icon")[0];
          if (domI) {
            domI.remove();
            let domR = domChirld[domChirldIndex].getElementsByClassName(
              "van-step__circle-container"
            )[0];

            let jumpDom = document.createElement("img");
            jumpDom.src = this.jumpFlow;
            jumpDom.style.width = "1em";
            jumpDom.style.height = "1em";
            jumpDom.style.zIndex = "333";
            domR.appendChild(jumpDom);
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.stepBody {
  overflow: auto;
  background-color: #fff;
}
/deep/.van-steps--horizontal {
  padding: 24px 30px 0;
}
/deep/.van-steps--horizontal .van-steps__items {
  margin: 0;
}
/deep/.van-steps {
  overflow: initial;
}
/deep/.van-step--horizontal:first-child .van-step__title {
  transform: translateX(-50%);
}
/deep/.van-step--horizontal:last-child .van-step__title {
  transform: translateX(50%);
}
/deep/.van-step--horizontal .van-step__line {
  width: 110px;
  border-top: 2px dashed #ebedf0;
  background-color: transparent;
}
/deep/.van-step--horizontal .van-step__circle-container {
  padding: 0;
}
/deep/.van-step:last-child .van-step__line {
  width: 0;
}
/deep/.van-step--finish .van-step__line {
  border: 0;
  height: 2px;
}
/deep/.van-step--horizontal .van-step__line {
  left: -3px;
}
/deep/.van-steps--horizontal .van-steps__items {
  padding-bottom: 0.16rem;
}
/deep/.van-step--horizontal .van-step__title {
  padding-top: 0.1rem;
}
/deep/.van-step--horizontal .van-step__circle-container {
  top: 0;
}
/deep/.van-step--horizontal .van-step__line {
  top: 0;
}
/*修改滚动条样式*/
.stepBody::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
#removeLeft {
  position: relative;
  box-sizing: border-box;
  background: #fff;
  z-index: 99;
}
.van-step--horizontal:last-child .van-step__circle-container {
  right: -5px;
}
.normalStyle {
  overflow-y: auto;
  // -webkit-overflow-scrolling: touch;
}
/deep/ .footer .van-button--disabled {
  background: #ccc;
}
.van-step--horizontal {
  text-align: left;
}
.van-step--finish {
  color: #e12817;
}
/deep/ .van-cell {
  font-size: 0.12rem;
}
/deep/ .van-field__label {
  width: 6.6em;
}
/deep/ .van-dialog__message {
  font-size: 0.17rem;
  line-height: 1.5;
}
.van-swipe {
  background: #fff;
}
.van-swipe-item {
  font-size: 0.14rem;
  padding: 0.15rem 0;
  position: relative;
  // width: 50% !important;
}
.van-swipe-item::after {
  position: absolute;
  content: "";
  left: 0;
}
.active {
  color: #e12817;
  width: 200px !important;
  text-align: right;
}
/deep/ .van-swipe__indicator--active {
  background-color: #e12817 !important;
  // margin-right: 100px;
  // width: 200px!important;
}
/deep/ .van-swipe__indicator:not(:first-child) {
  width: 6px;
}
/deep/ .van-swipe__indicator {
  // width: 240px!important;
  background: #ccc;
  position: relative;
}
/deep/ .van-swipe__indicator::after {
  // width: 240px!important;
  position: absolute;
  content: "";
  border-top: 1px dashed red;
  width: 20px;
  top: 3px;
}
/deep/ .van-swipe__indicators {
  top: 10px;
  // width: 240px!important;
  // background: #ccc;
}
</style>